module.exports = __webpack_public_path__ + "img/285.512e704d.png";